import { z } from "zod";
import type { DefaultValues } from "react-hook-form";
import { validateLatitude, validateLongitude } from "@utils/formatters";

export const cameraTrapEditSchema = z.object({
  number: z.string().min(1, "Número do dispositivo é obrigatório"),
  responsibleTeam: z.string().optional(),
  latitude: z
    .string({ message: "Latitude é obrigatória" })
    .min(1, "Latitude é obrigatória")
    .refine(validateLatitude(), {
      message: "Latitude deve estar entre -90 e 90",
    }),
  longitude: z
    .string({ message: "Longitude é obrigatória" })
    .min(1, "Longitude é obrigatória")
    .refine(validateLongitude(), {
      message: "Longitude deve estar entre -180 e 180",
    }),
});

export type CameraTrapEditFormData = z.infer<typeof cameraTrapEditSchema>;

export const cameraTrapEditDefaultValues: DefaultValues<CameraTrapEditFormData> =
  {
    number: "",
    responsibleTeam: "",
    latitude: "",
    longitude: "",
  };
